export enum LegendPlacement {
    Right = "right",
    Bottom = "bottom"
}
